import { Body } from "@vds/typography";
import React from "react";
import styled from "styled-components";

const AddressWrapper = styled.div`
#addressTitle{
    margin-bottom:5px ;
}
`;
class Address extends React.PureComponent {
    constructor(props, context) {
        super(props, context);
    }
    render() {
        const { line1 } =  this.props.address ? this.props.address : '';
        const { line2 } =  this.props.address ? this.props.address : '';
        const { state } =  this.props.address ? this.props.address : '';
        const { city } =  this.props.address ? this.props.address : '';
        const { zip } =  this.props.address ? this.props.address : '';
        const  serviceAddress  = this.props.serviceAddress ? this.props.serviceAddress : '';
        return (<AddressWrapper>
            <Body size="small"
                color="#000000"
                id="addressTitle"
                bold={true}
            >Address</Body>
            {serviceAddress && 
            <Body size="small"
            color="#000000"
            bold={false}>{serviceAddress}</Body>
            }
            {line1 && 
            <Body size="small"
            color="#000000"
            bold={false}>{line1},</Body>
            }
           {line2 && 
            <Body size="small"
                color="#000000"
                bold={false}>{line2}</Body>
            }
           {(city || state || zip) &&
            <Body size="small"
                color="#000000"
                bold={false}>{city}, {state} {zip}</Body>
            }
        </AddressWrapper>
        )
    }
}

export default Address;
